import { defineComponent as _defineComponent } from 'vue'
import { renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createVNode as _createVNode, createElementVNode as _createElementVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = (n: any) => (_pushScopeId("data-v-76bb09fd"),n=n(),_popScopeId(),n)
const _hoisted_1 = {
  key: 0,
  class: "kima-breadcrumb"
}
const _hoisted_2 = { class: "container" }
const _hoisted_3 = { key: 1 }

import { computed } from "vue"
import { useRoute } from "vue-router"

type BreadcrumbItem = {
  key?: string,
  value: string
}


export default /*#__PURE__*/_defineComponent({
  __name: 'DefaultBreadcrumb',
  setup(__props) {

const route = useRoute()

const isHome = computed(() => {
  const path = (route.path || '/').replace(/\/+$/, '') || '/'
  return path === '/' || path === ''
})

const breadcrumbs = computed<BreadcrumbItem[]>(() => {
  return (route.meta?.breadcrumb as BreadcrumbItem[]) || []
})

const showBreadcrumb = computed(() => {
  return !isHome.value && breadcrumbs.value.length > 0
})

return (_ctx: any,_cache: any) => {
  const _component_router_link = _resolveComponent("router-link")!
  const _component_a_breadcrumb_item = _resolveComponent("a-breadcrumb-item")!
  const _component_a_breadcrumb = _resolveComponent("a-breadcrumb")!

  return (showBreadcrumb.value)
    ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
        _createElementVNode("div", _hoisted_2, [
          _createVNode(_component_a_breadcrumb, null, {
            default: _withCtx(() => [
              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(breadcrumbs.value, (item, index) => {
                return (_openBlock(), _createBlock(_component_a_breadcrumb_item, { key: index }, {
                  default: _withCtx(() => [
                    (item.key)
                      ? (_openBlock(), _createBlock(_component_router_link, {
                          key: 0,
                          to: item.key
                        }, {
                          default: _withCtx(() => [
                            _createTextVNode(_toDisplayString(_ctx.$t(item.value)), 1)
                          ]),
                          _: 2
                        }, 1032, ["to"]))
                      : (_openBlock(), _createElementBlock("span", _hoisted_3, _toDisplayString(_ctx.$t(item.value)), 1))
                  ]),
                  _: 2
                }, 1024))
              }), 128))
            ]),
            _: 1
          })
        ])
      ]))
    : _createCommentVNode("", true)
}
}

})